import React, { createContext, useContext, useState, useCallback } from 'react';

const FiltersContext = createContext();

export const useFilters = () => {
  const context = useContext(FiltersContext);
  if (!context) {
    throw new Error('useFilters must be used within a FiltersProvider');
  }
  return context;
};

export const FiltersProvider = ({ children }) => {
  const [onFiltersClick, setOnFiltersClick] = useState(null);

  const registerFiltersHandler = useCallback((handler) => {
    setOnFiltersClick(() => handler);
  }, []);

  const unregisterFiltersHandler = useCallback(() => {
    setOnFiltersClick(null);
  }, []);

  return (
    <FiltersContext.Provider value={{
      onFiltersClick,
      registerFiltersHandler,
      unregisterFiltersHandler
    }}>
      {children}
    </FiltersContext.Provider>
  );
};
